import { ref, watchEffect } from 'vue';
import useFetch from '@/composables/useFetch';

export default function (endPoint) {
  const searchQuery = ref('');
  const suggestions = ref(null);
  const fetchData = useFetch();
  watchEffect((onInvalidate) => {
    if (searchQuery.value.length < 2) {
      suggestions.value = null;
      return;
    }

    const fetchTimer = setTimeout(async () => {
      const { fetchResult, fetchError } = await fetchData(endPoint + searchQuery.value);

      if (!fetchError.value) suggestions.value = fetchResult.value.slice(0, 8);
    }, 250);
    onInvalidate(() => {
      clearTimeout(fetchTimer);
    });
  });
  return {
    searchQuery,
    suggestions,
  };
}
